import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Spin,
  Col,
  Select,
  Form,
  Divider,
} from "antd";
import { Checkbox } from "antd/es";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";

const { Text } = Typography;

const ViewGLA0300 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const {
    viewFinanceRuleDetail,
    finPeriodStart,
    finPeriodEnd,
    finYearEnd,
    localCurrency,
    revaluationOptions,
    comMonthlyGlBalance,
    reportLargeMovement,
    allowReversalAcrossPeriod,
    allowReversalAcrossFinYear,
    pLAccountProfitGL,
    pLAccountLossGL,
  } = appLabel;
  const { months, viewFinanceRuleItems, monthList } = appStatic;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [financeRuleDetail, setFinanceRuleDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [check, setCheck] = useState(true);
  const [currencyData, setCurrencyData] = useState([]);

  useEffect(() => {
    // console.log(state);
    getDetailById(state);
    getCurrency();
  }, []);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.DetailFinanceRules}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setFinanceRuleDetail(objDetail);

        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });

        setIsLoading(false);
      }
    });
  };

  function getCurrency() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.CurrencyList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.selectedCurrencyOptions;
        let temp = [];

        console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(temp);
      }
    });
  }

  const handleOnDelete = () => {
    let action = "Delete  ";
    let label = "finance rule";
    // console.log(body);return

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${definedApi.DeleteFinaceRules}/${state.key}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, appLabel.deleteFinanceRuleMsg);
            navigate("/gla0300");
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={viewFinanceRuleDetail}
        pageItems={viewFinanceRuleItems}
      />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}

        <Form
          form={useForm}
          layout="vertical"
          style={{ paddingTop: 20, marginBottom: 50 }}
        >
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Divider orientation="left" orientationMargin="0">
                  {appLabel.currencyInfo}
                </Divider>
                <Form.Item
                  label={
                    <Text style={{ fontSize: "16px" }}>{finPeriodStart}</Text>
                  }
                >
                  <Input
                    style={{ width: "30vh" }}
                    className="of-bold-disable-input"
                    disabled
                    value={monthList[financeRuleDetail?.periodStartMonth - 1]}
                  />
                </Form.Item>
                <Form.Item
                  label={
                    <Text style={{ fontSize: "16px" }}>{finPeriodEnd}</Text>
                  }
                >
                  <Input
                    style={{ width: "30vh" }}
                    className="of-bold-disable-input"
                    disabled
                    value={monthList[financeRuleDetail?.periodEndMonth - 1]}
                  />
                </Form.Item>
                <Form.Item
                  label={<Text style={{ fontSize: "16px" }}>{finYearEnd}</Text>}
                >
                  <Input
                    style={{ width: "30vh" }}
                    className="of-bold-disable-input"
                    disabled
                    value={
                      monthList[financeRuleDetail?.financialYearEndMonth - 1]
                    }
                  />
                </Form.Item>
              </Row>

              <Row style={{ justifyContent: "space-between" }}>
                <Divider orientation="left" orientationMargin="0">
                  {appLabel.glAccountOptions}
                </Divider>
                <Col>
                  <Form.Item>
                    <Checkbox
                      style={{ width: "30vh" }}
                      disabled
                      checked={financeRuleDetail?.reportLargeMovement}
                    >
                      <Text style={{ fontSize: "16px" }}>
                        {reportLargeMovement}
                      </Text>
                    </Checkbox>
                  </Form.Item>
                  <div hidden={!financeRuleDetail?.reportLargeMovement}>
                    <Form.Item name="movementValue">
                      <Input disabled style={{ width: "30vh" }} />
                    </Form.Item>
                  </div>
                </Col>
                <Col>
                  <Text
                    style={{ fontSize: "16px" }}
                  >{`${revaluationOptions}:`}</Text>
                  <Form.Item>
                    <Checkbox
                      style={{ width: "30vh" }}
                      disabled
                      checked={financeRuleDetail?.allowPeriodReversal}
                    >
                      <Text style={{ fontSize: "16px" }}>
                        {allowReversalAcrossPeriod}
                      </Text>
                    </Checkbox>
                  </Form.Item>
                  <Form.Item>
                    <Checkbox
                      style={{ width: "30vh" }}
                      disabled
                      checked={financeRuleDetail?.allowFinancialYearReversal}
                    >
                      <Text style={{ fontSize: "16px" }}>
                        {allowReversalAcrossFinYear}
                      </Text>
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Form.Item>
                  <Checkbox
                    style={{ width: "30vh" }}
                    disabled
                    checked={financeRuleDetail?.computeAvgBalance}
                  >
                    <Text style={{ fontSize: "16px" }}>
                      {comMonthlyGlBalance}
                    </Text>
                  </Checkbox>
                </Form.Item>
              </Row>

              <Row justify={"space-between"}>
                <Divider orientation="left" orientationMargin="0">
                  {appLabel.plInfo}
                </Divider>

                <Form.Item
                  label={
                    <Text style={{ fontSize: "16px" }}>{localCurrency}</Text>
                  }
                >
                  <Input
                    style={{ width: "30vh" }}
                    disabled
                    className="of-bold-disable-input"
                    value={financeRuleDetail?.localCurrencyCode}
                  />
                </Form.Item>

                <Form.Item
                  label={
                    <Text style={{ fontSize: "16px" }}>
                      {pLAccountProfitGL}
                    </Text>
                  }
                >
                  <Select
                    style={{ width: "30vh" }}
                    className="of-bold-disable-input"
                    showSearch
                    disabled
                    value={financeRuleDetail?.plProfitGL?.name}
                  />
                  <Text strong style={{ marginLeft: "15px", fontSize: "16px" }}>
                    {financeRuleDetail?.plProfitGL?.glCode}
                  </Text>
                </Form.Item>
                <Form.Item
                  name="plAccountLossGl"
                  label={
                    <Text style={{ fontSize: "16px" }}>{pLAccountLossGL}</Text>
                  }
                >
                  <Select
                    placeholder={"Please Select a value"}
                    style={{ width: "30vh" }}
                    className="of-bold-disable-input"
                    showSearch
                    disabled
                    value={financeRuleDetail?.plLossGL?.name}
                  />
                  <Text strong style={{ marginLeft: "15px", fontSize: "16px" }}>
                    {financeRuleDetail?.plLossGL?.glCode}
                  </Text>
                </Form.Item>
              </Row>
            </Card>
          </Card>
        </Form>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewGLA0300);
